import React from "react";

function Logo() {
  return (<div className="text-6xl font-face-black text-black dark:text-white">Isaac</div>);
}

export default Logo;